/* eslint-disable @typescript-eslint/no-empty-pattern */
import { CoreHTTPBaseRepository } from "src/contexts/_shared/infrastructure/core/CoreHTTPBaseRepository";
import { AuthRepository, GetTokenParams, SendTwoFactorParams } from "../domain/AuthRepository";
import { delay } from "src/contexts/_shared/utils";

export class StaticAuthRepository extends CoreHTTPBaseRepository implements AuthRepository {
  public sendTwoFactor = async ({}: SendTwoFactorParams) => {
    await delay(2000);
  };

  public getToken = async ({}: GetTokenParams) => {
    await delay(2000);
    return "random-access-token";
  };
}
